module.exports = __webpack_public_path__ + "static/media/localcity.11255266.png";